import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import DocBoxFreeSearchModel from './docbox-free-search.model';
import { Store } from '@ngrx/store';
import { DocBoxState, FormsState, getDocBoxFromSideMenu } from '@evorait/pace-forms';
import { Observable, Subject } from 'rxjs';
import { getDocBoxSelector } from 'libs/pace-forms/src/lib/store/selectors/docBox.selector';
import { distinctUntilChanged, takeUntil, tap } from 'rxjs/operators';
import { UiResponsiveService } from '@evorait/pace-core';

@Component({
    selector: 'pace-docbox-free-search',
    templateUrl: './docbox-free-search.component.html',
    styleUrls: ['./docbox-free-search.component.scss'],
})
export class DocBoxFreeSearchComponent implements OnInit, OnDestroy {
    public model: DocBoxFreeSearchModel;
    public formChildren: FormArray;
    public docBoxFreeSearchForm: FormGroup;
    public docBox$: Observable<DocBoxState>;
    protected isSearchFormExpanded = false;
    protected isMobile = false;
    public showErrorMessage = false;
    private destroyTrigger$ = new Subject<void>();
    public constructor(
        private readonly formBuilder: FormBuilder,
        private readonly store: Store<FormsState>,
        private readonly uiResponsiveService: UiResponsiveService,
    ) {
        this.model = new DocBoxFreeSearchModel();
    }

    public ngOnInit(): void {
        this.uiResponsiveService.isMobile$
            .pipe(takeUntil(this.destroyTrigger$), distinctUntilChanged())
            .subscribe((isMobile) => {
                this.isMobile = isMobile;
                this.isSearchFormExpanded = !isMobile;
            });
        this.formChildren = this.formBuilder.array([]);
        this.docBoxFreeSearchForm = this.formBuilder.group({
            formChildren: this.formChildren,
        });
        this.docBox$ = this.store.select(getDocBoxSelector).pipe(
            tap((docbox) => {
                if (docbox.docBoxFiles?.length > 0) {
                    this.showErrorMessage = false;
                }
            }),
        );
    }

    public ngOnDestroy(): void {
        this.destroyTrigger$.next();
        this.destroyTrigger$.complete();
    }

    public validateForm(): void {
        this.model.resetModelOptions();
        this.formChildren.controls.forEach((control) =>
            control.updateValueAndValidity({ onlySelf: false, emitEvent: true }),
        );
        this.showErrorMessage = this.formChildren.controls.every((control) => control.invalid);
    }

    public searchDocuments(): void {
        this.store.dispatch(
            getDocBoxFromSideMenu({
                materialNumber: this.model.material.value ?? '',
                serialNumber: this.model.serialNo.value ?? '',
                functionalLocation: this.model.functionalLoc.value ?? '',
                technicalIdentNo: this.model.technicalIdentNo.value ?? '',
            }),
        );
        this.showErrorMessage = true;
    }

    public toggleSearchFormExpanded(): void {
        this.isSearchFormExpanded = !this.isMobile || !this.isSearchFormExpanded;
    }

    public createErrorMessage(): string {
        const { technicalIdentNo, functionalLoc, material, serialNo } = this.model;

        if (technicalIdentNo.value) {
            return `No documents available for Technical Ident No. ${technicalIdentNo.value}`;
        }

        if (functionalLoc.value) {
            return `No documents available for Functional Location No. ${functionalLoc.value}`;
        }

        if (material.value && serialNo.value) {
            return `No documents available for Material No. ${material.value} and Serial No. ${serialNo.value}`;
        }

        return '';
    }
}
